module.exports = __webpack_public_path__ + "static/media/facebook.a927c7f5.svg";